import '@material/web/all.js'; // This often imports a large set of common components.
// Or, for a smaller bundle, you can import specific components:
// import '@material/web/button/filled-button.js';
// import '@material/web/textfield/filled-text-field.js';

// You can also import the typography styles here.
import {styles as typescaleStyles} from '@material/web/typography/md-typescale-styles.js';
document.adoptedStyleSheets.push(typescaleStyles.styleSheet);